import { isModalShown } from '../../components/common/modal-message/modal-message.selectors';
import { NOTIFICATION_PLACEMENT } from '../../components/common/notifications/notifications.constants';
import { NotificationModel } from '../../components/common/notifications/notifications.types';
import { THEME } from '../../constants/notification';
import { Dispatch, GetState } from '../redux.types';

export const NAMES = {
  ADD_NOTIFICATION: 'ADD_NOTIFICATION',
  ADD_NOTIFICATIONS: 'ADD_NOTIFICATIONS',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  REMOVE_NOTIFICATION: 'REMOVE_NOTIFICATION',
};

const addNotification =
  (notification: NotificationModel) => (dispatch, getState?) => {
    const state = getState();
    const isModalOpen: boolean = isModalShown(state);

    return dispatch({
      type: NAMES.ADD_NOTIFICATION,
      payload: {
        placement:
          notification.placement ||
          (isModalOpen
            ? NOTIFICATION_PLACEMENT.MODAL
            : NOTIFICATION_PLACEMENT.GLOBAL),
        ...notification,
      },
    });
  };

const showNotification =
  (notification: NotificationModel) => (dispatch: Dispatch) => {
    return dispatch({
      type: NAMES.SHOW_NOTIFICATION,
      payload: notification,
    });
  };

const addNotifications =
  (notifications: NotificationModel[]) =>
  (dispatch: Dispatch, getState: GetState) => {
    const state = getState();
    const isModalOpen: boolean = isModalShown(state);

    return dispatch({
      type: NAMES.ADD_NOTIFICATIONS,
      payload: {
        placement: isModalOpen
          ? NOTIFICATION_PLACEMENT.MODAL
          : NOTIFICATION_PLACEMENT.GLOBAL,
        ...notifications,
      },
    });
  };

const removeNotification = (notification) => (dispatch: Dispatch) => {
  return dispatch({
    type: NAMES.REMOVE_NOTIFICATION,
    payload: notification,
  });
};

const addErrorNotification =
  (notification) => (dispatch: Dispatch, getState: GetState) =>
    addNotification({
      ...notification,
      theme: THEME.ERROR,
    })(dispatch, getState);

const addSuccessNotification =
  (notification) => (dispatch: Dispatch, getState: GetState) =>
    addNotification({
      ...notification,
      theme: THEME.SUCCESS,
    })(dispatch, getState);

const addWarningNotification =
  (notification) => (dispatch: Dispatch, getState: GetState) =>
    addNotification({
      ...notification,
      theme: THEME.WARNING,
    })(dispatch, getState);

export {
  addNotification,
  addNotifications,
  showNotification,
  removeNotification,
  addErrorNotification,
  addSuccessNotification,
  addWarningNotification,
};
